import loadStorageData from 'shared/Storage';

import {CALL_API} from 'middleware/api';

import {LOAD_STORAGE} from '../Storage';

export const RESTORE = 'RESTORE';
export const SUCCESS_RESTORE = 'SUCCESS_RESTORE';
export const FAILURE_RESTORE = 'FAILURE_RESTORE';

function fetchRestore(data) {
    return {
        type: RESTORE,
        [CALL_API]: {
            endpoint: '/api/sign/restore',
            method: 'post',
            types: [
                [SUCCESS_RESTORE, loadStorageData, LOAD_STORAGE],
                FAILURE_RESTORE
            ],
            credentials: true,
            data
        }
    };
}

export function loadAuth(data) {
    return (dispatch) => {
        return dispatch(fetchRestore(data));
    };
}



// WEBPACK FOOTER //
// ./js/actions/auth/loadAuthAction.js